<!--
 * @Author: LCJ
 * @Date: 2025-12-25 13:58:36
 * @LastEditTime: 2026-05-07 11:29:36
 * @LastEditors: LCJ
 * @Description: 
 * @FilePath: \code\schoolDistricts\src\views\MyMap.vue
-->
<!--
 * @Author: LCJ
 * @Date: 2025-12-25 13:58:36
 * @LastEditTime: 2026-02-05 16:47:58
 * @LastEditors: LCJ
 * @Description: 
 * @FilePath: \schoolDistricts\src\views\MyMap.vue
-->
<template>
  <div class="map">
    <!-- 市五区选择 -->
    <el-select class="chooseArea" v-model="areaValue" placeholder="请选择" @change="getAreaValue">
      <el-option v-for="item in optionsArea" :key="item.index" :label="item.label" :value="item.site">
      </el-option>
    </el-select>
    <!-- 搜索区域 -->
    <el-input placeholder="请输入内容" v-model="inputValue" class="input-with-select">
      <el-select v-model="typeSelect" slot="prepend">
        <el-option label="小区" value="小区"></el-option>
        <el-option label="学校" value="学校"></el-option>
      </el-select>
      <el-button slot="append" icon="el-icon-search" @click="searchPoi"></el-button>
    </el-input>
    <!-- 地图 -->
    <div id="map"></div>
    <!-- 右边详细信息区域 -->
    <div class="msgPane">
      <SchoolList ref="schoolPage" />
    </div>
    <!-- 结果列表 -->
    <ResultPane ref="resultPage" />
    <!-- 下载列表 -->
    <DownLaodPane />
    <Register />
  </div>
</template>

<script>
import SchoolList from "../components/SchoolList.vue";
import ResultPane from "../components/ResultPane.vue";
import DownLaodPane from "../components/DownloadList.vue";
import Register from "../components/Register.vue";
import aiPiture from "@/assets/aiPicture.png";
import { supermapArrayToGeoJSON } from '@/utils/supermap';
export default {
  name: "MyMap",
  components: {
    SchoolList,
    ResultPane,
    DownLaodPane,
    Register,
  },
  data() {
    return {
      optionsArea: [
        {
          site: [28.08, 112.96, "长沙市"],
          label: "长沙市",
        },
        {
          site: [28.19635, 112.90625, "湘江新区"],
          label: "湘江新区",
        },
        {
          site: [28.18865, 113.02665, "芙蓉区"],
          label: "芙蓉区",
        },
        {
          site: [28.11755, 112.98418, "天心区"],
          label: "天心区",
        },
        {
          site: [28.23844, 112.92581, "开福区"],
          label: "开福区",
        },
        {
          site: [28.13894, 113.03224, "雨花区"],
          label: "雨花区",
        },
        {
          site: [28.24973, 113.07479, "长沙县"],
          label: "长沙县",
        },
        {
          site: [28.35699, 112.82582, "望城区"],
          label: "望城区",
        },
        {
          site: [28.16727, 113.6377, "浏阳市"],
          label: "浏阳市",
        },
        {
          site: [28.28125, 112.54663, "宁乡市"],
          label: "宁乡市",
        },
      ],
      areaValue: "长沙市",
      inputValue: "",
      typeSelect: "学校",
      map: "",
      quResultLayer: "",
      resultLayer: "",
      pointResultLayer: "",
      housePointLayer: "",
      // 根据环境自动切换：develop模式空字符串走代理，production模式直接请求
      tdtBaseUrl: process.env.VUE_APP_TDT_BASE_URL,
      // tdtBaseUrl: "http://192.168.246.1:8090",
      xybBaseUrl: "https://zwfw.zrzyt.hunan.gov.cn",
      xuequUrl:
        "/iserver/services/map-EncryptOther/rest/maps/XueQu",
      dataUrl:
        "/iserver/services/data-EncryptOther/rest/data",
      //dataUrl:
      // "/iserver/services/data-XueXiaoXueQu/rest/data",
      // toIndex: 520,
    };
  },
  mounted() {
    const hash = window.location.hash;
    const queryString = hash.substring(hash.indexOf('?') + 1);
    const params = new URLSearchParams(queryString);
    if (params.get('from') == 'zrzy_qjd') {
      this.xuequUrl = this.xybBaseUrl + this.xuequUrl + `?apikey=${process.env.VUE_APP_TDT_API_KEY}`
      this.dataUrl = this.xybBaseUrl + this.dataUrl + `?apikey=${process.env.VUE_APP_TDT_API_KEY}`
    } else {
      this.xuequUrl = this.tdtBaseUrl + this.xuequUrl + `?apikey=${process.env.VUE_APP_TDT_API_KEY}`
      this.dataUrl = this.tdtBaseUrl + this.dataUrl + `?apikey=${process.env.VUE_APP_TDT_API_KEY}`
    }
    this.addMap();
    // this.schoolInfo();
    window.vueInstance = this;
    // this.test()
  },
  beforeDestroy() {
    // 移除挂载在 window 上的 Vue 实例
    if (window.vueInstance) {
      delete window.vueInstance;
    }
  },
  methods: {
    // 唤起ai
    openAi(name) {
      this.$nextTick(() => {
        this.$refs.schoolPage.openAIpop(name);
      });
    },
    test() {
      const sqlParam = new SuperMap.GetFeaturesBySQLParameters({
        queryParameter: {
          name: "192_168_246_5_5432_tdt",
          attributeFilter: "name like '%白云村%'",
        },
        datasetNames: ["192_168_246_5_5432_tdt:PLAPT"],
        toIndex: 520,
      });
      L.supermap
        .featureService(this.tdtBaseUrl + "/iserver/services/data-HNPOI/rest/data/")
        .getFeaturesBySQL(sqlParam, async (serviceResultData) => {
          const supermapData = window.hntdt.api.decrypt(serviceResultData.result.data)
          console.log("结果", supermapArrayToGeoJSON(supermapData.features));

        });
    },
    schoolInfo() {
      const sqlParam = new SuperMap.GetFeaturesBySQLParameters({
        queryParameter: {
          // name: "EncryptOther",
          attributeFilter: `SMID > 0`,
        },
        datasetNames: ["EncryptOther:学区范围汇总"],
        toIndex: 520,
      });
      // L.supermap
      //   .featureService(this.dataUrl)
      //   .getFeaturesBySQL(sqlParam, (serviceResultData) => {
      //     console.log("原始数据",serviceResultData);

      //     this.$refs.schoolPage.showTableData(
      //       serviceResultData.result.features.features
      //     );
      //   });
      L.supermap
        .featureService("https://hunan.tianditu.gov.cn/proxy-iserver/iserver/services/data-XueXiaoXueQu/rest/data/?apikey=" + process.env.VUE_APP_TDT_API_KEY)
        .getFeaturesBySQL(sqlParam, async (serviceResultData) => {
          const result = DecryptUtil.decryptAll(serviceResultData.result)
          // console.log("加密数据", serviceResultData.result);
          // console.log("解密数据", result.features);

          this.$refs.schoolPage.showTableData(
            supermapArrayToGeoJSON(result.features).features
          );
        });
    },
    getAreaValue(value) {
      this.map.setView(value, 12);
      const quName = this.areaValue[2];
      this.$refs.schoolPage.showLoading();
      this.$refs.schoolPage.changeAreaValue(quName);
      this.removeAll();
      //显示区范围并放在最底层
      const quSqlParam = new SuperMap.GetFeaturesBySQLParameters({
        queryParameter: {
          name: "EncryptOther",
          attributeFilter: `NAME = '${quName}'`,
        },
        datasetNames: ["EncryptOther:CHANGSHA"],
      });
      L.supermap
        .featureService(this.dataUrl)
        .getFeaturesBySQL(quSqlParam, (serviceResult) => {
          // const result = DecryptUtil.decryptAll(serviceResultData.result)
          // const resultGeoJSON = supermapArrayToGeoJSON(result.features).features
          const supermapData = window.hntdt.api.decrypt(serviceResult.result.data)
          const resultGeoJSON = supermapArrayToGeoJSON(supermapData.features)
          this.quResultLayer = L.geoJSON(resultGeoJSON, {
            stroke: true,
            color: "#E6A23C",
            weight: 3,
          })
            .addTo(this.map)
            .bringToBack();
        });
      //获取学区表格列表
      if (quName == "长沙市") {
        const sqlParam = new SuperMap.GetFeaturesBySQLParameters({
          queryParameter: {
            // name: "EncryptOther",
            attributeFilter: `SMID > 0`,
          },
          datasetNames: ["EncryptOther:学区范围汇总"],
          toIndex: 520,
        });
        L.supermap
          .featureService(this.dataUrl)
          .getFeaturesBySQL(sqlParam, (serviceResultData) => {
            // const result = DecryptUtil.decryptAll(serviceResultData.result)
            // const resultGeoJSON = supermapArrayToGeoJSON(result.features).features
            const supermapData = window.hntdt.api.decrypt(serviceResultData.result.data)
            const resultGeoJSON = supermapArrayToGeoJSON(supermapData.features)
            this.$refs.schoolPage.showTableData(
              resultGeoJSON.features
            );
          });
      } else {
        const sqlParam = new SuperMap.GetFeaturesBySQLParameters({
          queryParameter: {
            name: "EncryptOther",
            attributeFilter: `XIAN = '${quName}'`,
          },
          datasetNames: ["EncryptOther:学区范围汇总"],
          toIndex: 520,
        });
        L.supermap
          .featureService(this.dataUrl)
          .getFeaturesBySQL(sqlParam, (serviceResultData) => {
            // const result = DecryptUtil.decryptAll(serviceResultData.result)
            // const resultGeoJSON = supermapArrayToGeoJSON(result.features).features
            console.log("获取到的数据",serviceResultData.result.data)
            const supermapData = window.hntdt.api.decrypt(serviceResultData.result.data)
            const resultGeoJSON = supermapArrayToGeoJSON(supermapData.features)
            this.$refs.schoolPage.showTableData(
              resultGeoJSON.features
            );
          });
      }
    },
    addMap() {
      console.log(222)
      // that = this;
      this.map = L.map("map", {
        center: [28.08, 112.96],
        minZoom: 7,
        maxZoom: 18,
        zoom: 10,
        zoomControl: false,
        logoControl: false,
        attributionControl: false,
        crs: L.CRS.TianDiTu_WGS84,
      });
      L.supermap
        .tiandituTileLayer({
          layerType: "vec",
          key: "1d109683f4d84198e37a38c442d68311",
        })
        .addTo(this.map);
      L.supermap
        .tiandituTileLayer({
          isLabel: true,
          key: "1d109683f4d84198e37a38c442d68311",
        })
        .addTo(this.map);
      L.supermap
        .tiledMapLayer(this.xuequUrl, {
          transparent: true,
          opacity: 0.5,
        })
        .addTo(this.map);
      let filterParameter = new SuperMap.FilterParameter({
        attributeFilter: `SMID > 0`,
        // name: "EncryptOther",
      });
      console.log(filterParameter)
      let sqlParam = new SuperMap.GetFeaturesBySQLParameters({
        queryParameter: filterParameter,
        datasetNames: ["EncryptOther:学区范围汇总"],
        toIndex: 520,
      });
      L.supermap
        .featureService(this.dataUrl, {
          headers: {
            'x-tdt-encrypt-key-code': 'hntdt'
            // 添加你需要的其他请求头
          }
        })
        .getFeaturesBySQL(sqlParam, (serviceResultData) => {
          console.log("获取到的数据",serviceResultData);

          const supermapData = window.hntdt.api.decrypt(serviceResultData.result.data)
          console.log("解密后的数据",supermapData)
          const resultGeoJSON = supermapArrayToGeoJSON(supermapData.features)
          this.$refs.schoolPage.showTableData(
            resultGeoJSON.features
          );
          L.geoJSON(resultGeoJSON, {
            onEachFeature: (feature, layer) => {
              layer.setStyle({
                stroke: true,
                color: "#409EFF",
                opacity: 0,
                weight: 5,
                fillColor: "#50c9ff",
                fillOpacity: "0",
              });
              layer.on("mouseover", (e) => {
                layer.setStyle({
                  opacity: 1,
                });
              });
              layer.on("mouseout", (e) => {
                layer.setStyle({
                  opacity: 0,
                });
              });
              layer.on("click", (e) => {
                if (this.quResultLayer) {
                  this.map.removeLayer(this.quResultLayer);
                }
                this.searchSchoolByName(feature.properties.NAME);
                console.log(feature.properties.NAME);
              });
            },
          }).addTo(this.map);
          // this.$refs.schoolPage.showTableData(
          //   serviceResultData.result.features.features
          // );
        });
    },
    moveToSchool(lat, lon) {
      this.map.setView([lat, lon], 13);
    },
    // 根据学校名查学校
    searchSchoolByName(value) {
      this.removeAllLayer();
      this.map.closePopup();
      this.$refs.schoolPage.changeSchoolNameShow(value);
      const sqlParam = new SuperMap.GetFeaturesBySQLParameters({
        queryParameter: {
          name: "EncryptOther",
          attributeFilter: `NAME = '${value}'`,
        },
        datasetNames: ["EncryptOther:学区范围汇总"],
      });
      L.supermap
        .featureService(this.dataUrl)
        .getFeaturesBySQL(sqlParam, (serviceResult) => {
          const supermapData = window.hntdt.api.decrypt(serviceResult.result.data)
          const resultGeoJSON = supermapArrayToGeoJSON(supermapData.features)
          this.resultLayer = L.geoJSON(resultGeoJSON, {
            stroke: true,
            color: "#409EFF",
            weight: 3,
            fillColor: "#409EFF",
            fillOpacity: "0.3",
          }).addTo(this.map);
          // this.resultLayer
          //   .bindPopup(
          //     serviceResult.result.features.features[0].properties.NAME + "学区"
          //   )
          //   .openPopup();
          const name = `${resultGeoJSON.features[0].properties.NAME}学区`;
          const htmlContent = `
              <div class="infoDiv">
                <p class="infoDiv_name">${resultGeoJSON.features[0].properties.NAME}学区</p>
                <div class="infoDiv_img" onclick="window.vueInstance.openAi('${name}')">
                  <img src=${aiPiture} />
                </div>
              </div>
              `;
          this.resultLayer.bindPopup(htmlContent).openPopup();
          this.map.setView(
            [
              resultGeoJSON.features[0].properties.LAT,
              resultGeoJSON.features[0].properties.LON,
            ],
            13
          );
          this.searchHouseBySchool(resultGeoJSON.features[0]);
        });
    },
    searchPoi() {
      if (this.inputValue == "") {
        this.$message({
          showClose: true,
          message: "请输入搜索内容",
          type: "error",
          offset: 100,
        });
      } else {
        if (this.typeSelect == "学校") {
          const sqlParam = new SuperMap.GetFeaturesBySQLParameters({
            queryParameter: {
              name: "EncryptOther",
              attributeFilter: `NAME like '%${this.inputValue}%'`,
            },
            datasetNames: ["EncryptOther:学区范围汇总"],
            // toIndex: 520,
          });
          L.supermap
            .featureService(this.dataUrl)
            .getFeaturesBySQL(sqlParam, (serviceResultData) => {
              const supermapData = window.hntdt.api.decrypt(serviceResultData.result.data)
              const resultGeoJSON = supermapArrayToGeoJSON(supermapData.features)
              const featureData = resultGeoJSON;
              if (featureData.features.length == 0) {
                this.$message({
                  showClose: true,
                  message: "查无数据",
                  type: "error",
                  offset: 100,
                });
              } else {
                //把查到的传给结果页面，用于列表显示
                this.$refs.resultPage.getResultDatas(featureData);
              }
            });
        } else {
          const sqlParam = new SuperMap.GetFeaturesBySQLParameters({
            queryParameter: {
              name: "EncryptOther",
              attributeFilter: `XIAOQU like '%${this.inputValue}%'`,
            },
            datasetNames: ["EncryptOther:小区查询点汇总"],
            toIndex: 500,
          });
          L.supermap
            .featureService(this.dataUrl)
            .getFeaturesBySQL(sqlParam, (serviceResultData) => {
              const supermapData = window.hntdt.api.decrypt(serviceResultData.result.data)
              const resultGeoJSON = supermapArrayToGeoJSON(supermapData.features)
              const featureData = resultGeoJSON;

              if (featureData.features.length == 0) {
                this.$message({
                  showClose: true,
                  message: "查无数据",
                  type: "error",
                  offset: 100,
                });
              } else {
                this.$refs.resultPage.getXiaoquResultDatas(featureData);
              }
            });
        }
      }
    },
    showMyChooseSchool(data) {
      console.log(data);
      this.removeAllLayer();
      this.map.closePopup();
      const poiName = data.properties.NAME;
      const sqlParam = new SuperMap.GetFeaturesBySQLParameters({
        queryParameter: {
          name: "EncryptOther",
          attributeFilter: `NAME = '${poiName}'`,
        },
        datasetNames: ["EncryptOther:学区范围汇总"],
      });
      L.supermap
        .featureService(this.dataUrl)
        .getFeaturesBySQL(sqlParam, (serviceResult) => {
          const supermapData = window.hntdt.api.decrypt(serviceResult.result.data)
          const resultGeoJSON = supermapArrayToGeoJSON(supermapData.features)
          if (resultGeoJSON.features.length == 0) {
            this.$message({
              showClose: true,
              message: "查无数据",
              type: "error",
              offset: 100,
            });
          } else {
            //显示学校区域
            this.resultLayer = L.geoJSON(resultGeoJSON, {
              stroke: true,
              color: "#409EFF",
              weight: 3,
              fillColor: "#409EFF",
              fillOpacity: "0.3",
            }).addTo(this.map);
            // this.resultLayer
            //   .bindPopup(
            //     serviceResult.result.features.features[0].properties.NAME +
            //       "学区"
            //   )
            //   .openPopup();
            const name = `${resultGeoJSON.features[0].properties.NAME}学区`;
            const htmlContent = `
              <div class="infoDiv">
                <p class="infoDiv_name">${resultGeoJSON.features[0].properties.NAME}学区</p>
                <div class="infoDiv_img" onclick="window.vueInstance.openAi('${name}')">
                  <img src=${aiPiture} />
                </div>
              </div>
              `;
            this.resultLayer.bindPopup(htmlContent).openPopup();
            this.map.setView([data.properties.LAT, data.properties.LON], 13);
            // 改变学校名的显示
            this.$refs.schoolPage.changeSchoolNameShow(poiName);
            this.searchHouseBySchool(data);
          }
        });
    },
    // 根据学校名称查小区的函数
    searchHouseBySchool(data) {
      console.log(data);
      if (this.housePointLayer) {
        this.map.removeLayer(this.housePointLayer);
      }
      const name = data.properties.NAME; //这个是学校名
      const sqlParam = new SuperMap.GetFeaturesBySQLParameters({
        queryParameter: {
          name: "EncryptOther",
          attributeFilter: `NAME = '${name}'`,
        },
        datasetNames: ["EncryptOther:小区查询点汇总"],
      });
      L.supermap
        .featureService(this.dataUrl)
        .getFeaturesBySQL(sqlParam, (serviceResultData) => {
          const supermapData = window.hntdt.api.decrypt(serviceResultData.result.data)
          const resultGeoJSON = supermapArrayToGeoJSON(supermapData.features)
          this.$refs.schoolPage.showSchoolHouseBySearch(
            resultGeoJSON.features
          );
          this.housePointLayer = L.geoJSON(resultGeoJSON, {
            onEachFeature: (point, latlng) => {
              // latlng.bindPopup(point.properties.XIAOQU);
              const name = `${point.properties.XIAOQU}`;
              const htmlContent = `
              <div class="infoDiv">
                <p class="infoDiv_name">${point.properties.XIAOQU}</p>
              </div>
              `;
              latlng.bindPopup(htmlContent);
            },
          }).addTo(this.map);
        });
    },
    // 显示用户选中的小区
    showMyChooseHouse(data) {
      console.log(data);
      this.map.closePopup();
      if (this.housePointLayer) {
        this.map.removeLayer(this.housePointLayer);
      }
      const sqlParam = new SuperMap.GetFeaturesBySQLParameters({
        queryParameter: {
          name: "EncryptOther",
          attributeFilter: `XIAOQU like '%${data}%'`,
        },
        datasetNames: ["EncryptOther:小区查询点汇总"],
        toIndex: 500,
      });
      L.supermap
        .featureService(this.dataUrl)
        .getFeaturesBySQL(sqlParam, (serviceResultData) => {
          const supermapData = window.hntdt.api.decrypt(serviceResultData.result.data)
          const resultGeoJSON = supermapArrayToGeoJSON(supermapData.features)
          const featureData = resultGeoJSON.features[0];
          console.log(featureData);
          this.housePointLayer = L.geoJSON(
            resultGeoJSON
          ).addTo(this.map);
          // this.housePointLayer
          //   .bindPopup(featureData.properties.XIAOQU)
          //   .openPopup();
          const name = `${featureData.properties.XIAOQU}`;
          const htmlContent = `
              <div class="infoDiv">
                <p class="infoDiv_name">${featureData.properties.XIAOQU}</p>
              </div>
              `;
          this.housePointLayer.bindPopup(htmlContent).openPopup();
          this.map.setView(
            [featureData.properties.LAT, featureData.properties.LON],
            16
          );
        });
    },
    // 清除地图上不要的元素
    removeAllLayer() {
      if (this.resultLayer) {
        this.map.removeLayer(this.resultLayer);
      }
      if (this.housePointLayer) {
        this.map.removeLayer(this.housePointLayer);
      }
    },
    // 清除地图上所有的元素
    removeAll() {
      this.map.closePopup();
      if (this.resultLayer) {
        this.map.removeLayer(this.resultLayer);
      }
      if (this.pointResultLayer) {
        this.map.removeLayer(this.pointResultLayer);
      }
      if (this.housePointLayer) {
        this.map.removeLayer(this.housePointLayer);
      }
      if (this.quResultLayer) {
        this.map.removeLayer(this.quResultLayer);
      }
    },
  },
};
</script>

<style scoped lang="scss">
:deep(.leaflet-popup-content) {
  .infoDiv {
    width: 100%;
    // display: flex;
    // align-items: center;
    // justify-content: space-between;

    .infoDiv_name {
      font-size: 16px;
      // margin-right: 1px;
      line-height: 1.5;
    }

    .infoDiv_img {
      position: absolute;
      right: 8px;
      top: 50%;
      transform: translate(0, 24%);
      width: 25px;
      height: 25px;
      cursor: pointer;

      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}

.map {
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;

  #map {
    width: 100%;
    height: 100%;
    overflow: hidden;
  }

  .chooseArea {
    position: absolute;
    top: 100px;
    left: 20px;
    z-index: 20001;
    width: 100px;
  }

  .input-with-select {
    position: absolute;
    top: 100px;
    left: 140px;
    z-index: 20001;
    width: 380px;

    :deep(.el-input-group__prepend) {
      width: 40px;
    }
  }

  @media screen and (max-width: 767px) {
    .chooseArea {
      position: absolute;
      top: 55px;
      left: 5px;
      z-index: 20001;
      width: 22%;
    }

    .input-with-select {
      position: absolute;
      top: 55px;
      left: calc(22% + 20px);
      width: calc(78% - 25px);
      z-index: 20001;

      :deep(.el-input-group__prepend) {
        width: 35px;
      }
    }
  }
}
</style>
